import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { WebsitesComponent } from './websites.component';
import { ModalWindowModule } from '../modal-window/modal-window.module';
import { WebsiteFormModule } from './components/website-form/website-form.module';

@NgModule({
  declarations: [WebsitesComponent],
  imports: [SharedModule, ModalWindowModule, WebsiteFormModule],
  exports: [WebsitesComponent],
})
export class WebsitesModule {}
